module.exports = __webpack_public_path__ + "c1678b46f7dd3f50ceac94ed4e0ad01a.ttf";